import React from "react";
import "./notification.css";

const NotificationContent = ({ icon, message, time, btn }) => {
  return (
    <>
      <div className="notification-body">
        <img src={icon} alt="notification-icon" />
        <div className="notification-msg">
          <p>{message}</p>
          <div>
            <p className="notification-time">{time}</p>

            <div>{btn}</div>
          </div>
        </div>
      </div>
      <hr />
    </>
  );
};

export default NotificationContent;
